import React from 'react';
import { BusinessJobResponse } from '../models';
import { Row, Stack } from 'library/ui';
import { BusinessSlot, ShiftMatch, ShiftJob, ShiftProvider } from 'models';
import { format12HourTime } from 'shared/Dates';
import { TitleDescription } from './TitleDescription';
import { MatchStatusChips } from '../../BusinessCalendar/ShiftCard/MatchStatusChips';
import { getShiftTimes } from '../../BusinessCalendar/ShiftCard/shiftTimesUtils';
import { EditPay } from '../../BusinessCalendar/ShiftCard/EditPay';

export function BusinessSlotSchedule({
    slot,
    job,
    provider,
    refresh,
}: {
    slot: BusinessSlot;
    job: BusinessJobResponse['job_details'] | ShiftJob;
    provider?: ShiftProvider;
    refresh: () => void;
}) {
    const matches = slot.appointments.reduce((x: ShiftMatch[], appt) => [...x, ...(appt.matches ?? [])], []);
    const { shiftStart, shiftEnd, infoText } = getShiftTimes(slot);
    const timezone = job.timezone;
    const workerPay = provider?.pay;

    return (
        <Stack gap="md">
            <Row gap="lg" wrap>
                <TitleDescription
                    title="Schedule"
                    description={`${format12HourTime(shiftStart, timezone)} - ${format12HourTime(shiftEnd, timezone, true)}`}
                    infoText={infoText}
                />
                <Row gap="sm">
                    <TitleDescription
                        title={job.pay || workerPay ? 'Pay' : 'Pay Scale'}
                        description={
                            job.pay || workerPay
                                ? `$${workerPay ?? job.pay}/hr`
                                : `$${job.rate_min} - ${job.rate_max}/hr`
                        }
                    />
                    <EditPay
                        visible={!!provider}
                        pay={workerPay}
                        jobId={job.id}
                        provider={provider?.provider}
                        refresh={refresh}
                    />
                </Row>
            </Row>
            <MatchStatusChips matches={matches} />
        </Stack>
    );
}
